import { define, ui } from '@owenscorning/pcb.alpha';

export default define`Jump To Solution Center`('0.0.1')({
  gutterless: true,
  view: () => (
    <UI.Modules.Page.Reusable
      value={{ name: 'BSSC - Jump to Solution Center' }}
    />
  ),
  edit: {},
});
